
(function () {
  const root = document.querySelector('[data-gm-np-confirm]');
  if (!root) return;

  const endpoint = (root.dataset.endpoint || '').trim();
  const panels = {
    invalid: root.querySelector('[data-gm-np-confirm-invalid]'),
    form: root.querySelector('[data-gm-np-confirm-form]'),
    loading: root.querySelector('[data-gm-np-confirm-loading]'),
    success: root.querySelector('[data-gm-np-confirm-success]'),
  };
  const orderLabel = root.querySelector('[data-gm-np-confirm-order]');
  const msg = root.querySelector('[data-gm-np-confirm-msg]');
  const submit = root.querySelector('[data-gm-np-confirm-submit]');

  const params = new URLSearchParams(window.location.search);
  const order = (params.get('order') || '').trim();
  const token = (params.get('token') || '').trim();

  const show = (name) => {
    Object.keys(panels).forEach((k) => {
      if (panels[k]) panels[k].hidden = k !== name;
    });
  };

  const showMsg = (text) => {
    if (!msg) return;
    msg.textContent = text;
    msg.hidden = !text;
  };

  if (!order || !token || !endpoint || endpoint.indexOf('example.com') !== -1) {
    show('invalid');
    return;
  }

  if (orderLabel) orderLabel.textContent = `№ ${order}`;
  show('form');

  submit?.addEventListener('click', async () => {
    const selector = root.querySelector('[data-gm-np-root]');
    const np = selector && selector.gmNpSelector;
    if (!np || !np.isComplete()) {
      showMsg('Оберіть місто та відділення.');
      return;
    }
    showMsg('');
    show('loading');

    const values = np.values();
    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          order: order,
          token: token,
          np_city: values.city,
          np_city_ref: values.cityRef,
          np_branch: values.branch,
          np_branch_ref: values.branchRef,
          np_branch_type: values.branchType,
        }),
      });
      const data = await res.json().catch(() => null);
      if (!res.ok || !data || data.ok === false) {
        throw new Error((data && data.error) || `HTTP ${res.status}`);
      }
      show('success');
    } catch (err) {
      show('form');
      showMsg('Не вдалося зберегти. Спробуйте ще раз або зателефонуйте нам.');
    }
  });
})();
